/**
 * Laster ned en URL som blob og lagrer den med ønsket filnavn. Brukes fordi
 * emulatorens media-URL ikke setter Content-Disposition; et blob: (same-origin)
 * lar `download`-attributtet styre filnavnet i alle miljøer.
 */
export async function downloadUrlAsFile(url: string, fileName: string): Promise<void> {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Nedlasting feilet med status ${response.status}`);
  }
  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = objectUrl;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  setTimeout(() => URL.revokeObjectURL(objectUrl), 0);
}
